import reduce from 'lodash/reduce';
import forEach from 'lodash/forEach';
import EventEmitter from 'wolfy87-eventemitter';
import MESSAGE_TYPES from '../../../constants/MESSAGE_TYPES';
import Messager from '../../messager';
import { ICategory, IIncomeCategoryData, ISelectedCategory } from '../../../types/category';
import { ISelectedTicket } from '../../../types/ticket';
import { isInViewport } from '../../../helpers/elements';
import { CATEGORIES_EVENTS } from '../../../constants/CONTROLLERS_EVENT_TYPES';

export class CategoriesController extends EventEmitter {
  categories: { [key: string]: ICategory } = {};

  categoriesPaths: { [key: string]: SVGPathElement[] } = {};

  categoriesWithTicketsIds: string[] = [];

  selectedCategory: string = null;

  selectedCategories: { [key: string]: ISelectedCategory } = {};

  pricesSet: Set<number> = new Set();

  colors: { [key: string]: string } = {};

  setCategories(categories: IIncomeCategoryData[], selectedTickets?: ISelectedTicket[]) {
    this.pricesSet = new Set();
    this.colors = {};

    const { selectedEvent, meta } = window.Widget.metaController;

    this.categories = categories.reduce((acc, category) => {
      const {
        d: categoryId,
        i: label,
        ex: additionalServices,
        extra,
        c: count,
        k: hashForbasket,
        description = '',
        paths,
        color,
        images,
        tt,
        at,
      } = category;
      let { p: price } = category;

      if (extra?.netto_price) {
        price = extra.netto_price;
      }

      const id = meta.isPeriodical ? `${selectedEvent}_${categoryId}` : categoryId;
      this.categoriesWithTicketsIds.push(id);

      acc[id] = {
        id,
        description,
        paths,
        color,
        label,
        ex: additionalServices,
        extra,
        tt,
        at,
        images: images ? JSON.parse(images) : [],
      };

      if (count) {
        acc[id] = {
          ...acc[id],
          price,
          count,
          k: hashForbasket,
        };

        this.pricesSet.add(price);
        this.colors[price] = color;
      }

      return acc;
    }, {});

    if (selectedTickets) {
      const newSelectedTickets: { [key: string]: ISelectedCategory } = selectedTickets.reduce(
        (acc, ticket) => {
          if (this.categories[ticket.id]) {
            acc[ticket.id] = {
              ...this.categories[ticket.id],
              count: ticket.count,
            };
          }

          return acc;
        },
        {},
      );

      this.selectedCategories = {
        ...this.selectedCategories,
        ...newSelectedTickets,
      };
    }
  }

  getCategoriesOutlines = (categories = this.categories) => {
    const outlines: {
      [key: string]: {
        paths: string[];
        color: string;
        label: string;
        isCategory: boolean;
      };
    } = {};

    forEach(categories, (category: ICategory, id) => {
      if (window.Widget.isHybrid) {
        window.Widget.pricesController.pricesColors[category.price] &&
          (category.color = window.Widget.pricesController.pricesColors[category.price]);
      }

      outlines[id] = {
        // @ts-ignore
        paths: category.paths ? JSON.parse(category.paths) : undefined,
        color: category.color,
        label: category.label,
        isCategory: true,
      };
    });

    return outlines;
  };

  showCategoryModal(id: string) {
    this.selectedCategory = id;
    this.emit(CATEGORIES_EVENTS.SHOW_MODAL);
    Messager.send({
      type: MESSAGE_TYPES.CHANGE_HELP_STATE,
      isOpen: true,
    });
  }

  getSelectedCategories(): ISelectedCategory[] {
    return reduce(
      this.selectedCategories,
      (acc, value) => {
        if (value) {
          acc.push(value);
        }

        return acc;
      },
      [],
    );
  }

  addSilency(id: string, count: number) {
    const { selectedEvent, selectedDate } = window.Widget.metaController;

    this.selectedCategories[id] = this.selectedCategories[id] || {
      ...this.categories[id],
      count,
      ...(selectedEvent && { selectedEvent }),
      ...(selectedDate && { selectedDate }),
    };
    this.selectedCategories[id].count = count;

    this.emit(CATEGORIES_EVENTS.ADD);
  }

  add(id: string, count: number) {
    const { selectedEvent, selectedDate } = window.Widget.metaController;

    this.selectedCategories[id] = this.selectedCategories[id] || {
      ...this.categories[id],
      count,
      ...(selectedEvent && { selectedEvent }),
      ...(selectedDate && { selectedDate }),
    };
    this.selectedCategories[id].count = count;

    Messager.send({
      type: MESSAGE_TYPES.ADD_TICKET,
      ticket: {
        ...this.categories[id],
        count,
      },
    });

    Messager.send({
      type: MESSAGE_TYPES.UPDATE_TICKETS,
      tickets: this.getSelectedCategories(),
    });

    this.emit(CATEGORIES_EVENTS.ADD);
  }

  remove(id: string, count: number) {
    if (!this.selectedCategories[id]) return;

    this.selectedCategories[id].count = count;

    if (count === 0) {
      delete this.selectedCategories[id];
    }

    Messager.send({
      type: MESSAGE_TYPES.DELETE_TICKET,
      ticket: {
        ...this.categories[id],
        count,
      },
    });

    Messager.send({
      type: MESSAGE_TYPES.UPDATE_TICKETS,
      tickets: this.getSelectedCategories(),
    });
  }

  setSelectedCategories(tickets: ISelectedCategory[]) {
    this.selectedCategories = tickets.reduce((acc, ticket) => {
      if (this.selectedCategories[ticket.id]) {
        acc[ticket.id] = {
          ...this.selectedCategories[ticket.id],
          count: ticket.count,
        };
      }

      return acc;
    }, {});
  }

  getItemsViewport(): string[] {
    const itemsInViewport: string[] = [];
    this.categoriesWithTicketsIds.forEach((categoryId) => {
      if (
        this.categoriesPaths[categoryId].some((pathEl) =>
          isInViewport(pathEl, window.Widget.offsetLeft),
        )
      ) {
        itemsInViewport.push(...this.categories[categoryId].sectors, categoryId);
      }
    });

    return itemsInViewport;
  }
}
